import script from "./page-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./page-layout.vue?vue&type=script&setup=true&lang=js"

import "./page-layout.vue?vue&type=style&index=0&id=7bb9ce4a&lang=scss"

const __exports__ = script;

export default __exports__